import { ApiError } from "./client";

const CODE_TIMEOUT_CONFIRM = "TIMEOUT_CONFIRM";
const CODE_CAPACITY = "REHYDRATION_CAPACITY";

export const MSG_CAPACITY_EXCEEDED =
  "Limite de reidratações simultâneas atingido, tente em alguns minutos";

// extractTimeoutConfirmTrackingId returns the trackingId when the BFF
// responded 502 with code=TIMEOUT_CONFIRM — the operation likely started
// downstream and the front can keep polling progress instead of treating
// the call as a hard failure.
export function extractTimeoutConfirmTrackingId(err: unknown): string | null {
  if (!(err instanceof ApiError) || err.status !== 502) return null;
  if (!err.body || typeof err.body !== "object") return null;
  const candidate = err.body as { code?: unknown; trackingId?: unknown };
  if (candidate.code !== CODE_TIMEOUT_CONFIRM) return null;
  if (typeof candidate.trackingId !== "string" || !candidate.trackingId) {
    return null;
  }
  return candidate.trackingId;
}

export function extractBackendMessage(body: unknown, fallback: string): string {
  if (typeof body === "string" && body.trim().length > 0) {
    return body;
  }
  if (body && typeof body === "object") {
    const candidate = body as { error?: unknown; message?: unknown };
    if (
      typeof candidate.error === "string" &&
      candidate.error.trim().length > 0
    ) {
      return candidate.error;
    }
    if (
      typeof candidate.message === "string" &&
      candidate.message.trim().length > 0
    ) {
      return candidate.message;
    }
  }
  return fallback;
}

export function mapRehydrationError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 409) {
      return extractBackendMessage(
        err.body,
        "Já existe uma reidratação em andamento para este ticket. Aguarde a operação atual terminar.",
      );
    }
    // 429 com code=REHYDRATION_CAPACITY é o limite de reidratações; o 429 de
    // conta bloqueada (login) vem sem code e segue o tratamento genérico.
    if (
      err.status === 429 &&
      err.body &&
      typeof err.body === "object" &&
      (err.body as { code?: unknown }).code === CODE_CAPACITY
    ) {
      return MSG_CAPACITY_EXCEEDED;
    }
    if (err.status === 502) {
      return "Não foi possível iniciar a reidratação (downstream sem resposta)";
    }
    return extractBackendMessage(
      err.body,
      `Falha na requisição (status ${err.status})`,
    );
  }
  if (err instanceof TypeError) {
    return "Erro de rede";
  }
  if (err instanceof Error && err.message) {
    return err.message;
  }
  return "Erro inesperado";
}
